export const brandLogos = [
    {
        idx: 1,
        url: 'https://assets.stickpng.com/images/580b57fcd9996e24bc43c51f.png'
    },
    {
        idx: 2,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/2560px-Amazon_logo.svg.png'
    },
    {
        idx: 3,
        url: 'https://logos-download.com/wp-content/uploads/2016/02/Microsoft_Logo_2012.png'
    },
    {
        idx: 6,
        url: 'https://www.freepnglogos.com/uploads/intel-png-logo/intel-is-shipping-its-kaby-lake-processors-png-logo-1.png'
    },
    {
        idx: 4,
        url: 'https://upload.wikimedia.org/wikipedia/commons/9/96/Zoho-logo.png'
    },
    {
        idx: 5,
        url: 'https://i.pinimg.com/originals/8a/5b/fa/8a5bfaf3b1f90399966491d44ffebb64.png'
    },
    {
        idx: 8,
        url: 'https://cdn.pixabay.com/photo/2015/05/26/09/37/paypal-784404_1280.png'
    },
    {
        idx: 7,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/Airbnb_Logo_B%C3%A9lo.svg/1280px-Airbnb_Logo_B%C3%A9lo.svg.png'
    },
    {
        idx: 11,
        url: 'https://upload.wikimedia.org/wikipedia/en/thumb/0/0f/Ola_Cabs_logo.svg/2560px-Ola_Cabs_logo.svg.png'
    },
    {
        idx: 9,
        url: 'https://logos-download.com/wp-content/uploads/2016/07/Airtel_logo.png'
    },
    {
        idx: 10,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8d/Adobe_Corporate_Logo.png/1200px-Adobe_Corporate_Logo.png'
    },
    {
        idx: 12,
        url: 'https://cdn.cookielaw.org/logos/aa498dad-1691-4c3b-894a-906c990be323/eab8b6ff-57d6-438a-a7e5-c58dd370ce73/000d8b20-8c3d-4f4f-a0da-5b515f8f20d2/Square_combinationmark_black.png'
    },
    {
        idx: 13,
        url: 'https://upload.wikimedia.org/wikipedia/en/thumb/1/12/Swiggy_logo.svg/2560px-Swiggy_logo.svg.png'

    },
    {
        idx: 14,
        url: 'https://www.edigitalagency.com.au/wp-content/uploads/Linkedin-logo-png.png'
    },
    {
        idx: 16,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Accenture.svg/2560px-Accenture.svg.png'
    },
    {
        idx: 17,
        url: 'https://logos-download.com/wp-content/uploads/2016/09/Myntra_logo.png'
    },
    {
        idx: 18,
        url: 'https://upload.wikimedia.org/wikipedia/commons/4/42/Paytm_logo.png?20170729032638'
    },
    {
        idx: 19,
        url: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/ByteDance_logo.png'
    },
    {
        idx: 19,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Capgemini_201x_logo.svg/1280px-Capgemini_201x_logo.svg.png'
    },
    {
        idx: 20,
        url: 'https://assets.stickpng.com/images/60895ec7d598a5000448ea97.png'
    },
    {
        idx: 21,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/HubSpot_Logo.svg/2560px-HubSpot_Logo.svg.png'
    },
    {
        idx: 22,
        url: 'https://logos-download.com/wp-content/uploads/2021/01/PhonePe_Logo_full.png'
    },
    {
        idx: 23,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Dell_Logo.png/1200px-Dell_Logo.png'
    },
    {
        idx: 15,
        url: 'https://upload.wikimedia.org/wikipedia/commons/7/7f/Ather_Energy_Pvt_Ltd_Logo.png'
    },
    {
        idx: 24,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Tech_Mahindra_New_Logo.svg/1200px-Tech_Mahindra_New_Logo.svg.png'
    },
    {
        idx: 25,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Skyroot-logo.svg/2560px-Skyroot-logo.svg.png'
    },
    {
        idx: 26,
        url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Byju%27s_logo.svg/2560px-Byju%27s_logo.svg.png'
    },
    {
        idx: 27,
        url: 'https://tradebrains.in/wp-content/uploads/2019/09/upstox-logo.png'
    },
    {
        idx: 28,
        url: 'https://upload.wikimedia.org/wikipedia/commons/b/bb/Groww_app_logo.png'
    },
    {
        idx: 29,
        url: 'https://1000logos.net/wp-content/uploads/2021/05/Tata-Cliq-logo.png'
    }

]